const x = {
  xs: "2px",
  s: "3px",
  md: "4px",
  lg: "6px",
  xl: "8px",
  "2xl": "12px",
  "3xl": "16px",
  "4xl": "18px"
};
export {
  x as CORNER_RADIUS
};
//# sourceMappingURL=index.es649.js.map
